module.exports = __webpack_public_path__ + "static/media/testimonials-2.08d8679b.jpg";